<div class="header">
  <div>
    <md-icon>speaker_notes</md-icon>
    <h3>Program Articles</h3>
  </div>
</div>
<div class="filters">
  <md-select name="destination"
    [disabled]="loading"
    [(ngModel)]="filters.defaultDestination"
    placeholder="Destination"
    (change)="refreshCharts()">
    <md-option *ngFor="let destination of destinations" [value]="destination">{{destination}}</md-option>
  </md-select>
  <md-select name="channel"
    [disabled]="loading"
    [(ngModel)]="filters.selectedChannel"
    placeholder="Channel"
    (change)="search()">
    <md-option *ngFor="let channel of channels" [value]="channel.id">{{channel.value}}</md-option>
  </md-select>
  <app-date-filter-picker [showMidnightMode]=false [isDashboard]=true></app-date-filter-picker>
</div> 

<br>

<app-spinner *ngIf="loading"></app-spinner>

<div class="error" *ngIf="!loading && (!charts || charts.length === 0)">
  <md-icon>
    directions_bike
  </md-icon>
  <p>No result... Try again !</p>
</div>

<div  *ngIf="!loading && charts && charts.length > 0">
        <div class="container" >
          <div class="chart" *ngFor="let chart of charts" >              
                <h4  class="title" >{{chart.title}}</h4>                
                <canvas #chartViews class="can-vas" baseChart [data]="chart.data" 
                                  [labels]="chart.labels" 
                                  [options] = "options"
                                  [chartType]="chart.type" 
                                  [colors]="colors"
                                  [legend]="true"
                                  [options]="options"
                                  (chartClick)="chartClick($event, chart)">
                </canvas>                
            </div>
        </div>
</div>


// WEBPACK FOOTER //
// ./src/app/components/program-article-dashboard/program-article-dashboard.component.html